import { render, staticRenderFns } from "./lahi-result-table.vue?vue&type=template&id=553b7560&scoped=true&lang=pug"
import script from "./lahi-result-table.vue?vue&type=script&lang=js"
export * from "./lahi-result-table.vue?vue&type=script&lang=js"
import style0 from "./lahi-result-table.vue?vue&type=style&index=0&id=553b7560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b7560",
  null
  
)

export default component.exports